import Vue from "vue";
import Vuex from "vuex";
import drawer from "./modules/drawer";
import auth from "./modules/auth";
import companies from "./collection/companies";
import shops from "./collection/shops";
import shopChannels from "./collection/shop-channels";
import docs from "./collection/docs";
import user from "./collection/user";
import summariesByCompany from "./collection/summaries-by-company";
import docsDownloadedByCompany from "./collection/docs-downloaded-by-company";
import docsDownloaded from "./collection/docs-downloaded";
import keyByCompany from "./collection/keys-by-company";
import databasesByCompany from "./collection/databases-by-company";
import paymentPlans from "./collection/paymentplans";
import partners from "./collection/partners";
import statusesByCompany from "./collection/statuses-by-company";
import loading from "./modules/loading";
import saleorders from "./collection/saleorders";
import thaismartTax from "./collection/taxstore";
import thaismartTaxPND54 from "./collection/thaismart-tax-pnd54";
import thaismartTaxDetail from "./collection/tax-detail-store";
import thaismartTaxPP36 from "./collection/thaismart-tax-pp36";
import purchase from "./collection/purchase";
import importDocs from "./modules/doc.js";
import uploadLog from "./modules/uploadLog.js";
import fileTracking from "./modules/fileTracking.js";
//exchange rate
import exchangeRate from "./collection/exchange-rate";
import accountspayable from "./collection/accountspayable";
import purchaseorders from "./collection/purchaseorders";
import fixedAssets from "./collection/fixed-asset-store";
import connectionHealth from "./modules/connectionHealth";
import devTools from "./modules/devTools";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  state: {
    apiUrl: "https://api.edamam.com/search",
  },
  mutations: {},
  actions: {},  modules: {
    auth,
    drawer,
    companies,
    shops,
    shopChannels,
    docs,
    user,
    exchangeRate,
    summariesByCompany,
    docsDownloadedByCompany,
    docsDownloaded,
    keyByCompany,
    databasesByCompany,
    paymentPlans,
    partners,
    statusesByCompany,
    loading,
    saleorders,
    thaismartTax,
    thaismartTaxPND54,
    thaismartTaxDetail,
    thaismartTaxPP36,
    purchase,
    importDocs,
    uploadLog,
    fileTracking,
    accountspayable,
    purchaseorders,
    fixedAssets,
    connectionHealth,
    devTools,
  },
  strict: debug,
});
